export const MIN_PASSWORD_LENGTH = 8;
export const ROWS_PER_PAGE = [10, 20, 50, 100, 250];

export const CANDIDATES_RIGHTS = ['admin.ac.candidates', 'admin.planning-orders.candidates'];
export const REPORTS_RIGHTS = ['admin.ac.reports', 'admin.planning-orders.reports'];
export const ANONYMIZED_VALUES = '••••••••••';

export enum DetailModes {
  new = 'new',
  edit = 'edit',
}
